import React from "react"
import { Link } from "react-router-dom";
import { MdChevronRight } from "react-icons/md";


export default function Social(){
    return(
        <div className="w-full mt-[6rem] mb-[3rem]">
            <div className="w-full items-start pl-[1.45rem] md:pl-[2.2rem] lg:pl-[3rem] py-[1rem] bg-[rgb(238,238,238)] md:bg-transparent lg:bg-transparent">
            <Link to='/aboutpage'>
            <span className="w-full flex items-center text-[rgb(136,136,136)]">
            <h1 className="uppercase text-sm md:text-lg lg:text-xl josefin-sans-p">
                About
            </h1>

            <MdChevronRight className="text-sm md:text-lg lg:text-xl"/>
            </span>
            </Link>

            <h1 className="uppercase mt-[1rem] font-[12px] md:font-[12px] lg:font-[12px] text-xl md:text-3xl lg:text-[3rem]">
            Social Responsibility
            </h1>

            </div>

            <div className='w-full mt-[2rem] flex items-center justify-center'>
                <p className='poetsen-one-regular sm:text-xs md:text-sm lg:text-sm sm:w-full md:w-[80%] lg:w-[60%]'>
                Archbuild Group, as well as achieving, through its main business, its company philosophy of "Contributing to Society through work of Value, thereby Fostering People and Advancing the Company", is also focused on Corporate Social Responsibility to create good corporate citizens to build society.
                </p>

            </div>

            <div className='w-full mt-[2rem] flex flex-col items-center justify-center'>
                <img src='https://www.nikken.co.jp/en/about/p4iusj0000001d81-img/CSR_top.jpg' alt='map' />

                <p className=''>
                Regular displays to provide information related to architectural technology are open to the public on the first floor of the Archbuild Tokyo building.
                </p>
            </div>

            <div className='w-full mt-[2rem] flex flex-col items-center justify-center px-2'>
                <div className=''>
                    <h1 className='poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                    Disaster assintance
                    </h1>
                
                    <div className="flex flex-col md:flex-col lg:flex-row sm:items-center md:items-center lg:items-start justify-center gap-2 sm:w-full md:w-[25rem] lg:w-[45rem] mt-[2rem]">
                <img src='https://www.nikken.co.jp/en/about/p4iusj0000001d81-img/DisasterAssistance_sample.jpg' alt='map' className='w-full md:w-[25rem] lg:w-[25rem] h-auto flex-shrink-0 img-hero' />

                <div className="mt-[0.5rem]">
                  <h3 className="text-lg font-bold dancing-script-big">Disaster volunteer support measures</h3>
                  
                  <p className="mt-[0.65rem] text-sm josefin-sans-p">Archbuild Group provides support to volunteer activities by Archbuild Group staff in areas devastated by the Great East Japan Earthquake.
                 ​</p>

                 
                </div>
                </div>

                </div>

                <h1 className='mt-[3rem] poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                Volunteer group
                </h1>
                <p className='poetsen-one-regular sm:text-xs md:text-sm lg:text-sm sm:w-full md:w-[80%] lg:w-[60%] mt-[1rem]'>
                The company volunteer Group (a recognized club activity within the company) uses its specialist knowledge to provide support to reconstruction after the Great East Japan Earthquake. They undertake unique projects in communication with people in the affected areas such as; presenting a 3D model of the damage in tsunami affected areas, various workshops, interviews with people from fields other than construction, cooperation with reconstruction plans and improvement of the home environment of temporary housing etc.
                </p>

                <h1 className='mt-[3rem] poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                Donations for conserving electricity
                </h1>
                <p className='poetsen-one-regular sm:text-xs md:text-sm lg:text-sm sm:w-full md:w-[80%] lg:w-[60%] mt-[1rem]'>
                Archbuild Group donated to the disaster relief effort for six months from March to August 2011, the money it saved from electricity conservation measures implemented immediately after the Great East Japan Earthquake
                </p>

                <h1 className='mt-[3rem] poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                Technical support to public agencies
                </h1>
                <p className='poetsen-one-regular sm:text-xs md:text-sm lg:text-sm sm:w-full md:w-[80%] lg:w-[60%] mt-[1rem]'>
                Archbuild Group is setting down response guidelines for support services in accordance with the requirements of the national government, regional municipalities, public agencies and the affected area in preparation for severe damage after a large-scale earthquake in a metropolitan area where buildings are highly concentrated.Specifically, Archbuild conducts hazard assessments for continued use of or access to damaged buildings etc. for the purpose of preventing secondary disasters due to the effect of aftershocks on damaged buildings and other civil structures as well as assessment of the dangers of falling exterior cladding and signs.
                </p>


                
            </div>


            <div className='flex flex-col items-center justify-center mt-[4rem] px-3 gap-5'>
            <div className=''>
                    <h1 className='poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                    Disaster assintance
                    </h1>
                
                    <div className="flex flex-col md:flex-col lg:flex-row sm:items-center md:items-center lg:items-start justify-center gap-2 sm:w-full md:w-[25rem] lg:w-[45rem] mt-[2rem]">
                <img src='https://www.nikken.co.jp/en/about/p4iusj0000001d81-img/Matizhai-Hope-Primary-School-.jpg' alt='map' className='w-full md:w-[25rem] lg:w-[25rem] h-auto flex-shrink-0 img-hero' />

                <div className="mt-[0.5rem]">
                  <h3 className="text-lg font-bold dancing-script-big">Matizhai Hope Primary School</h3>
                  
                  <p className="mt-[0.65rem] text-sm josefin-sans-p"> Archbuild Group has formed a professional volunteer team with two design offices in Shanghai to design the Matizhai Hope Primary School for the Chinese Hope school campaign to build and refurbish elementary schools in poverty stricken areas to provide assistance to children who can't go to school for economic reasons.
                 ​</p>

                 
                </div>
                </div>

                </div>


                <div className=''>
                    <h1 className='poetsen-one-regular text-lg md:text-2xl lg:text-3xl'>
                    Display Gallery
                    </h1>
                
                    <div className="flex flex-col md:flex-col lg:flex-row sm:items-center md:items-center lg:items-start justify-center gap-2 sm:w-full md:w-[25rem] lg:w-[45rem] mt-[2rem]">
                <img src='https://www.nikken.co.jp/en/about/p4iusj0000001d81-img/NikkenGallery_Sample.jpg' alt='map' className='w-full md:w-[25rem] lg:w-[25rem] h-auto flex-shrink-0 img-hero' />

                <div className="mt-[0.5rem]">
                  <h3 className="text-lg font-bold dancing-script-big">Matizhai Hope Primary School</h3>
                  
                  <p className="mt-[0.65rem] text-sm josefin-sans-p"> In the gallery on the first floor of the Tokyo building in Iidabashi, Chiyoda ward, regular displays of Archbuild's construction technology such as Architectural Design, Environment and Structure (seismic-resistance) are held for the benefit of local residents as well as people in construction related businesses.
                 ​</p>

                 
                </div>
                </div>

                </div>
            </div>



        </div>
    )
}